import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import cochabambaImg from "../assets/img/cocha.webp";
import monteroImg from "../assets/img/montero.webp";
import shinahotaImg from "../assets/img/shinaota.webp";
import santaCruzImg from "../assets/img/santacruz.png";
import tarijaImg from "../assets/img/tarija.webp";
import yacuibaImg from "../assets/img/yacuhiba.png";

import mapaBolivia from "../assets/img/pais.webp";
import marcador from "../assets/img/marcador.webp";
import fondoSedes from "../assets/img/fondoUnido.jpg";
import mscImg from "../assets/img/mSC.webp";
import mcbImg from "../assets/img/mcb.webp";
import mtrImg from "../assets/img/mtr.webp";

// 🔥 RECIBE startLoading
export default function SeleccionarSede({ startLoading }) {
  const navigate = useNavigate();
  const [activeSede, setActiveSede] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔥 FUNCIÓN PARA ACTIVAR LOADER ANTES DE NAVEGAR
  const handleSelect = (nombre) => {
    startLoading(); // 🔥 primero loader

    setTimeout(() => {
      navigate(`/${nombre.replace(/\s+/g, "")}`);
    }, 120); // pequeño delay para que el loader pinte primero
  };

  const sedes = [
    {
      nombre: "Santa Cruz",
      img: santaCruzImg,
      width: "115px",
      height: "170px",
      anchor: "bottom-right",
      disponible: true,
    },
    {
      nombre: "Montero",
      img: monteroImg,
      width: "120px",
      height: "180px",
      anchor: "bottom-right",
      disponible: false,
    },
    {
      nombre: "Tarija",
      img: tarijaImg,
      width: "125px",
      height: "165px",
      anchor: "bottom-right",
      disponible: true,
    },
    {
      nombre: "Cochabamba",
      img: cochabambaImg,
      width: "120px",
      height: "170px",
      anchor: "bottom-right",
      disponible: true,
    },
    {
      nombre: "Yacuiba",
      img: yacuibaImg,
      width: "130px",
      height: "150px",
      anchor: "bottom-left",
      disponible: true,
    },
    {
      nombre: "Shinahota",
      img: shinahotaImg,
      width: "150px",
      height: "150px",
      anchor: "bottom-left",
      disponible: true,
    },
  ];

  const markers = [
    { nombre: "Cochabamba", top: "47%", left: "23%" },
    { nombre: "Shinahota", top: "41%", left: "32%" },
    { nombre: "Montero", top: "37%", left: "51%" },
    { nombre: "Santa Cruz", top: "52%", left: "55%" },
    { nombre: "Tarija", top: "70%", left: "38%" },
    { nombre: "Yacuiba", top: "75.5%", left: "48%" },
  ];

  const regionMap = {
    Montero: {
      img: mscImg,
      top: "52.5%",
      left: "69.5%",
      width: "51%",
      height: "51%",
    },
    "Santa Cruz": {
      img: mscImg,
      top: "52.5%",
      left: "69.5%",
      width: "51%",
      height: "51%",
    },
    Shinahota: {
      img: mcbImg,
      top: "53.3%",
      left: "38%",
      width: "20%",
      height: "20%",
    },
    Cochabamba: {
      img: mcbImg,
      top: "53.3%",
      left: "38%",
      width: "20%",
      height: "20%",
    },
    Tarija: {
      img: mtrImg,
      top: "84.8%",
      left: "50.8%",
      width: "21.5%",
      height: "21.5%",
    },
    Yacuiba: {
      img: mtrImg,
      top: "84.8%",
      left: "50.8%",
      width: "21.5%",
      height: "21.5%",
    },
  };

  return (
    <section
      className="py-5 bg-light"
      style={{
        minHeight: "100vh",
        background: `linear-gradient(to right, rgba(0, 33, 130, 0.85), rgba(11, 67, 163, 0.75)), url(${fondoSedes}) center/cover no-repeat`,
      }}
    >
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2
            className="fw-bold text-white text-center"
            style={{ fontSize: isMobile ? "2.5em" : "3em" }}
          >
            Selecciona tu Sub Sede
          </h2>
          <p
            className="text-white text-center"
            style={{ fontSize: "1.2em", marginTop: isMobile ? "0.5em" : "1em" }}
          >
            Bienvenido a la Red Universitaria UNO
          </p>
        </motion.div>

        <div className={`row ${isMobile ? "pt-1" : "pt-5"} align-items-start`}>
          <div className="col-12 col-lg-6">
            <div className="row flex-wrap justify-content-center">
              {sedes.map((sede, i) => {
                const isActive = activeSede === sede.nombre;
                const opacity = activeSede && !isActive ? 0.3 : 1;

                return (
                  <motion.div
                    key={i}
                    className="col-6 col-md-4 col-lg-4 mb-4 d-flex justify-content-center"
                    initial={{ opacity: 0, y: 40, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 0.6, delay: i * 0.15 }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        cursor: sede.disponible ? "pointer" : "not-allowed",
                        opacity: sede.disponible ? opacity : 0.5,
                      }}
                      onMouseEnter={() => setActiveSede(sede.nombre)}
                      onMouseLeave={() => setActiveSede(null)}
                      onClick={() => {
                        if (sede.disponible) {
                          handleSelect(sede.nombre); // 🔥 cambio clave
                        }
                      }}
                    >
                      <div
                        style={{
                          height: isMobile ? "110px" : "100px",
                          width: isMobile ? "120px" : "120px",
                          backgroundColor: "#009dfa",
                          borderRadius: "0.8rem",
                          position: "relative",
                          overflow: "visible",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-end",
                        }}
                      >
                        <motion.img
                          src={sede.img}
                          alt={sede.nombre}
                          style={{
                            width: `calc(${sede.width} * ${isMobile ? 0.7 : 0.8})`,
                            height: `calc(${sede.height} * ${isMobile ? 0.7 : 0.8})`,
                            objectFit: "cover",
                            borderRadius: "0.5rem",
                            position: "absolute",
                            bottom: "0",
                            right:
                              sede.anchor === "bottom-right" ? "0" : "auto",
                            left: sede.anchor === "bottom-left" ? "0" : "auto",
                          }}
                          whileHover={{
                            scale: 1.15,
                            translateX:
                              sede.anchor === "bottom-right" ? "-6%" : "6%",
                            translateY: "-6%",
                          }}
                          transition={{ duration: 0.3 }}
                        />
                      </div>

                      <h5
                        className="mt-2 text-white fw-bold"
                        style={{
                          fontSize: isMobile ? "0.9rem" : "1rem",
                          marginBottom: isMobile ? "0rem" : "2.5rem",
                        }}
                      >
                        {sede.nombre}
                      </h5>

                      {!sede.disponible && (
                        <div
                          className="text-warning fw-bold"
                          style={{
                            fontSize: isMobile ? "0.7rem" : "0.85rem",
                            marginTop: isMobile ? "4px" : "-40px",
                            position: "relative",
                            zIndex: 5,
                          }}
                        >
                          En construcción
                        </div>
                      )}
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>

          {/* MAPA */}
          <div className="col-12 col-lg-6 text-center mt-1 mt-lg-0">
            <motion.div
              className="position-relative d-inline-block"
              initial={{ opacity: 0, scale: 0.9, y: 40 }}
              animate={{
                opacity: 1,
                scale: isMobile ? 1 : 1.2,
                y: isMobile ? 0 : -50,
              }}
              transition={{ duration: 0.8 }}
            >
              <div
                style={{
                  maxWidth: isMobile ? "300px" : "320px",
                  margin: isMobile ? "0px auto 0" : "50px auto -20px",
                  position: "relative",
                }}
              >
                <img
                  src={mapaBolivia}
                  className="img-fluid rounded"
                  alt="Mapa Bolivia"
                  style={{ width: "100%", height: "auto" }}
                />

                {/* 🔥 REGIONES DINÁMICAS */}
                {Object.entries(regionMap).map(([sede, data], i) => (
                  <motion.img
                    key={i}
                    src={data.img}
                    alt={sede}
                    className="position-absolute"
                    style={{
                      top: data.top,
                      left: data.left,
                      width: data.width,
                      height: data.height,
                      transform: "translate(-50%, -50%)",
                      objectFit: "contain",
                      zIndex: 2,
                    }}
                    animate={{ opacity: activeSede === sede ? 1 : 0 }}
                    transition={{ duration: 0.5 }}
                  />
                ))}

                {/* 🔥 MARCADORES */}
                {markers.map((m, i) => {
                  const isActive = activeSede === m.nombre;
                  const visible = !activeSede || isActive;
                  const arriba = ["Shinahota", "Montero", "Tarija"].includes(
                    m.nombre,
                  );

                  return (
                    <motion.div
                      key={i}
                      className="position-absolute d-flex flex-column align-items-center"
                      style={{ top: m.top, left: m.left, zIndex: 3 }}
                      animate={{
                        opacity: visible ? 1 : 0,
                        scale: visible ? 1 : 0.8,
                      }}
                      transition={{ duration: 0.5 }}
                      onMouseEnter={() => setActiveSede(m.nombre)}
                      onMouseLeave={() => setActiveSede(null)}
                    >
                      {arriba && (
                        <div
                          className="text-white px-2 py-1"
                          style={{
                            backgroundColor: "#001A66",
                            borderRadius: "50px",
                            fontSize: "0.75rem",
                          }}
                        >
                          {m.nombre}
                        </div>
                      )}

                      <motion.img
                        src={marcador}
                        alt={m.nombre}
                        style={{ width: "25px" }}
                        animate={{ scale: isActive ? 1 : 0.8 }}
                        transition={{ duration: 0.3 }}
                      />

                      {!arriba && (
                        <div
                          className="text-white px-2 py-1 small mt-1"
                          style={{
                            backgroundColor: "#001A66",
                            borderRadius: "50px",
                            fontSize: "0.75rem",
                          }}
                        >
                          {m.nombre}
                        </div>
                      )}
                    </motion.div>
                  );
                })}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
